import { Theme } from "@mui/material";
import { makeStyles } from "tss-react/mui";

export const useCardSectionStyles = makeStyles()((theme: Theme) => ({
  card: {
    boxShadow: "0 0 10px rgb(0 0 0 / 0.3)",
    borderRadius: "1rem",
  },
  sectionTitle: {
    textAlign: "start",
    color: theme.palette.info.dark,
    textTransform: "uppercase",
    fontWeight: "bold",
    marginBottom: "1rem",
  },
  sectionTitleError: {
    textAlign: "start",
    color: "red",
    textTransform: "uppercase",
    fontWeight: 700,
    marginBottom: "1rem",
  },
  inputContainer: {
    marginBottom: "1rem",
  },
  inputTitle: { color: theme.palette.info.dark, textAlign: "start" },
  radioButton: {
    "&.MuiRadio-root": {
      color: theme.palette.info.dark,
    },
    "&.Mui-checked": {
      color: theme.palette.info.dark,
    },
  },
  radioButtonTitle: {
    color: theme.palette.info.dark,
  },
  checkboxLabel: {
    textAlign: "start",
    "& .MuiFormControlLabel-label": {
      color: theme.palette.info.dark,
    },
    "& .MuiTypography-root.MuiTypography-body1.MuiFormControlLabel-label": {
      fontSize: "0.9rem",
    },
  },
  checkbox: {
    color: theme.palette.info.dark,
    "&.Mui-checked": {
      color: theme.palette.info.dark,
      "& svg": {
        color: theme.palette.info.dark,
      }
    },
  },
}));
